import { Grid, Stack, Typography } from "@mui/material"
import firebase from '../firebase';
import Button from './Button';
import ConfirmationResult = firebase.auth.ConfirmationResult;
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { getAuth, setPersistence, signInWithPhoneNumber, inMemoryPersistence } from "firebase/auth";

export const signInTitle = {margin: '1em 0', fontFamily: 'Lato'}

export const sendCodeNote = { margin: '1em 0', fontFamily: 'Lato', textAlign: 'center'}

declare global {
	/* Window has to be set this way in order to have it called. So that is why the naming convention is disabled for
	the next line. */
	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface Window {
		recaptchaVerifier: any;
		confirmationResult: ConfirmationResult;
	}
}

type props = {
    setIsVerified : React.Dispatch<React.SetStateAction<boolean>>;
    phoneNumberClient : string;
    handleNumber: (e: any) => void;
}


const MobileSignIn : React.FC<props> = (props) => {

    /**
     * Function sets up an invisible recaptcha verifier to use for sending
     * verification codes.
     */
    const setUpRecaptcha = (): void => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            size: 'invisible',
            callback: function (response: any): void {
                console.log('Captcha Resolved');
                props.setIsVerified(true)

            },
            defaultCountry: 'US'
        });
    };
    
    /**
     * Function uses firebase to send a text message to the user with a verification code
     *  the user then can enter the code which logs them into the web application
     * @param e is the event that triggered the function call
     */
    const onSignInSubmit = (e: any): void => {
        e.preventDefault();
        setUpRecaptcha();
        if (
            !/^\+\d+$/.test(props.phoneNumberClient)
        ) {
            alert('You must enter a valid phone number');
            return;
        }
        const phone = props.phoneNumberClient;
        const appVerifier = window.recaptchaVerifier;

        const auth = getAuth();
        firebase
            .auth()
            .signInWithPhoneNumber(phone, appVerifier)
            .then((confirmationResult) => {
                setPersistence(auth, inMemoryPersistence)
                .then(() => {
                return signInWithPhoneNumber(auth,phone,appVerifier);
                })
                // SMS sent. Prompt user to type the code from the message, then sign the
                // user in with confirmationResult.confirm(code).
                console.log('OTP is sent', confirmationResult);
                window.confirmationResult = confirmationResult;
            })
            .catch(function (error: Error) {
                console.log(error);
                // window.recaptchaVerifier.render();
                return;
        });
    };

    return(
        <>
        <Stack>
            <Grid item xs={12} id={'recaptcha-container'}></Grid>
            <Typography style={signInTitle}>
                Sign in with Phone Number
            </Typography>
            <form onSubmit={onSignInSubmit}>
                <PhoneInput
                    placeholder="Enter phone number"
                    value={props.phoneNumberClient}
                    onChange={props.handleNumber}
                    defaultCountry="US"
                    international={false}
                />
                {/* <TextField 
                    id="outlined-basic"
                    label="Phone Number" 
                    variant="outlined" 
                    style={{width: '100%'}}
                    value={props.phoneNumberClient}
                    onChange={props.handleNumber}
                    InputProps = {{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LocalPhoneIcon/>
                            </InputAdornment>
                        )
                    }}
                /> */}
                <Typography style={{ margin: '1em 0', fontFamily: 'Lato', textAlign: 'center'}} >
                    By tapping 'Send Verification Code', an SMS may be sent. Messages and data rates may apply.
                </Typography>
                <Button>
                    Send Verification Code
                </Button>
            </form>
        </Stack>
        </>

    )
}


export default MobileSignIn